var map = {
	"./brandConfig.ameland.tsx": 806,
	"./brandConfig.campercontact.tsx": 807,
	"./brandConfig.oberon.tsx": 808,
	"./brandConfig.schier.tsx": 809,
	"./brandConfig.terschelling.tsx": 810,
	"./brandConfig.texel.tsx": 811,
	"./brandConfig.uitinderegio.tsx": 812,
	"./brandConfig.visitwadden.tsx": 813,
	"./brandConfig.wadden.tsx": 814,
	"./brandConfig.waterland.tsx": 815,
	"./brandConfig.zandvoort.tsx": 816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 805;